import { RedirectConfig } from "./Redirect/RedirectConfig";
import { SamlConsumeConfig } from "./SamlConsume/SamlConsumeConfig";

export const UATAppsConfigs = [
    RedirectConfig,
    SamlConsumeConfig
];
